import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Variables } from 'src/app/Helpers/variables';

@Injectable({
  providedIn: 'root'
})
export class ExternalUserService implements CanActivate {

constructor() { }

canActivate() {
  const v = new Variables();
  const p = localStorage.getItem('ups');
  if (p == null) {
    return false;
  }
  const val = CryptoJS.AES.decrypt(p, v.pass).toString(CryptoJS.enc.Utf8);
  const perm = JSON.parse(val);
  if (perm.includes('USM.Section.ExternalUsers')
      || perm.includes('USM.Administration.Full')) {
        return true;
  } else {
    return false;
  }
}

}
